import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { css } from '@emotion/react';
import CloseSVG from '@birdi/icons/close.svg';
import { closeButtonCSS, contentCSS, portalCSS } from '@birdi/modal-kit';
import { BirdiTheme } from '@birdi/theme';
import { blocks } from '@birdi/theme'
import WarningSVG from '@birdi/icons/warning.svg';
import {
  buttonsHolderStyle,
  cancelButtonstyle,
  confirmButtonstyle,
} from '../../user-workspaces/delete-workspace-modal';

interface DeleteUserWarningModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  deleteConfirm: () => void;
}

export const DeleteUserWarningModal: React.FC<DeleteUserWarningModalProps> = ({
  open,
  setOpen,
  deleteConfirm,
}) => {

  const confirm = async () => {
    deleteConfirm();
  };
  const cancel = () => {
    setOpen(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay />

        <div css={portalCSS}>
          <Dialog.Content
            css={(theme: BirdiTheme) => css`
              ${contentCSS(theme)};
              overflow-y: auto;
            `}
          >
            <Dialog.Close css={closeButtonCSS}>
              <CloseSVG />
            </Dialog.Close>
            <div css={css`display: flex;
              justify-content: center;
              align-items: center;
              gap: 0.25em;
              font-size: 1.25em;
              font-weight: bold
              `}
            >
              <WarningSVG />
              <span>Warning:</span>
              <span css={css`font-weight: normal`}>
                Delete a user
              </span>
            </div>
            <hr />

            <div css={css`text-align: center`}>
              <p>
                You're about to delete a user, if this user is part of multiple workspaces. Removing them will revoke access to all workspaces, maps, and data across the platform.
                <br />
                <br />
                These changes are permanent and cannot be undone.
                <br />
                <br />
                <span css={css`font-weight: bold`}>
                  Are you sure you want to continue?
                </span>
              </p>

              <div css={buttonsHolderStyle}>
                <button
                  type="button"
                  css={cancelButtonstyle}
                  onClick={cancel}
                >
                  <span>Cancel</span>
                </button>
                <button
                  type="button"
                  css={confirmButtonstyle}
                  onClick={confirm}
                >
                  <span>Yes, delete user</span>
                </button>
              </div>

              <div
                css={css`
                  margin-top: 1.5em;
                `}
              >
                If you're having issues, contact support via chat from the dashboard or email{' '}
                <a css={blocks.linkPrimary} href="mailto:support@birdi.io">
                  support@birdi.io
                </a>
                .
              </div>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
